import { Component, OnInit, Input, Output, EventEmitter, ViewChildren, ViewContainerRef, QueryList } from '@angular/core';

import { DynamicComponent, HisNotificationService, HisUiService, HisGenericValueService } from 'hisng';

import { SEARCH_CONFIG_MINI_PROJECT } from 'app/fs/res/common/model/searchConstants';
import { DYNAMIC_FIELD_ANCHOR } from 'app/fs/res/common/model/dynamic-content/constants';
import { ProviderManager } from 'app/fs/res/common/utils/provider-manager';

import { ProjectService } from 'app/fs/res/finance/service/project/project.service';
import { Project } from 'app/fs/res/finance/model/project/project';

@Component( {
    selector: 'res-project-panel',
    templateUrl: './project-panel.component.html',
    providers: [ProviderManager.getComponentProvider(ProjectPanelComponent)],
} )
export class ProjectPanelComponent implements OnInit {
    @Input() dDKey: string;
    @Input() editMode = true;
    @Input() selectedProjects: Project[] = [];
    @Input() selectedProject: Project;
    @Input() dynamicComponent: DynamicComponent;
    @Output() selectedProjectsChange = new EventEmitter<Project[]>();
    @ViewChildren( DYNAMIC_FIELD_ANCHOR, { read: ViewContainerRef } ) fieldViewContainerList: QueryList<ViewContainerRef>;

    readonly SEARCH_CONFIG_MINI_PROJECT = SEARCH_CONFIG_MINI_PROJECT;
    public dateFormat: string;

    constructor(
        private hisUiService: HisUiService,
        private notificationService: HisNotificationService,
        private genericValueService: HisGenericValueService,
        private projectService: ProjectService
    ) { }

    /* Component ngOnInit */
    ngOnInit() {
        this.dateFormat = this.hisUiService.translate( 'common.dateFormat' );
        this.dDKey = this.dDKey ? this.dDKey : 'fs.res.common.projects';
    }

    onSelectBySearchPopup( event: any[] ) {
        if ( !event || event.length === 0 ) {
            // the selected list has been emptied
            this.selectedProjects = [];
            this.selectedProjectsChange.emit( this.selectedProjects );
        } else {
            // convert search result into Project[]
            let projectLids: Set<number> = new Set();
            for ( let option of event ) {
                let projectLid: number = parseInt( option.id, 10 );
                projectLids.add( projectLid );
            }
            this.projectService.getProjectsByIds( projectLids ).subscribe( (projects: Project[]) => {
                this.selectedProjects = projects;
                this.selectedProjectsChange.emit( this.selectedProjects );
            } );
        }
    }

    /**
     * Add new project selected by autocomplete to selected list.
     */
    onSelectByAutocomplete() {
        if ( !this.selectedProject ) {
            this.notificationService.errorI18nRes( 'fs.res.common.error.project' );
        } else {
            let containedProject =
                this.genericValueService.findRowByValue( this.selectedProjects, this.selectedProject.id );
            if ( !containedProject ) {
                this.projectService.getProjectById( this.selectedProject.id ).subscribe( (p: Project) => {
                    this.selectedProjects = [...this.selectedProjects, p];
                    this.selectedProjectsChange.emit( this.selectedProjects );
                    this.selectedProject = undefined;
                } );
            } else {
                this.notificationService.warn(
                    this.hisUiService.translate( 'fs.res.common.warning.project', containedProject.defaulttext ),
                    this.hisUiService.translate( 'fs.res.common.service.warn' )
                );
            }
        }
    }

    /**
     * remove project with given index
     *
     * @param project project to remove.
     */
    removeProject( project: Project ) {
        const index = this.selectedProjects.indexOf( project );
        this.selectedProjects = this.genericValueService.deleteRow( this.selectedProjects, index );
        this.selectedProjectsChange.emit( this.selectedProjects );
    }
}
